module.exports = __webpack_public_path__ + "static/img/khk004-ic.d2c3f30a.png";